import React from "react";
import classes from "./Chip.scss";
import { CloseOutlined } from "@toddle-edu/ds-icons";
import I18nHOC from "UIComponents/I18nHOC";
import classNames from "classnames";

const ActionChip = props => {
  const { icon, label, onClose = () => {}, t } = props;
  const chipLabelClass = classNames({
    [classes.chipLabel]: true,
    ["text-body-2"]: true,
  });
  return (
    <div className={classes.chipContainer}>
      <div className={classes.chipIcon}>{icon}</div>
      <div className={chipLabelClass}>{t(label)}</div>
      <CloseOutlined
        className={classes.chipCloseIcon}
        onClick={onClose}
        role="button"
        size="xxx-small"
      />
    </div>
  );
};

export default I18nHOC({ resource: ["common", "teacherHomePage"] })(ActionChip);
